import { useUserAccount } from '@/api/user/queries';
import styles from '../styles.module.scss';
import { ErrorLabelCoinProps } from './props';
import { WalletService } from '@starsoft/common/services';
import { Image } from '@starsoft/common/components';
import { getMoneyOrAmount } from '@/utils/account/getMoneyOrAmount';

export default function ErrorLabelCoin({ coin }: ErrorLabelCoinProps) {
  const { user } = useUserAccount();

  return (
    <div className={styles.container__row}>
      {WalletService.maskCurrency({
        amount: getMoneyOrAmount(coin?.minimumBetAmount) ?? 0,
        coin: coin,
      })}
      {user && (
        <Image
          className={styles.container__coin}
          width={16}
          height={16}
          alt={`coin-icon-${coin?.name}`}
          format="square"
          src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/coins/rounded/${coin?.image}`}
        />
      )}
    </div>
  );
}
